import PagerView from './pager';

export default PagerView.extend({
  handleInputChange() {
    if (this.isClosed) {
      return;
    }
    this.updatePager();
    this.outputCollection.reset(this.inputCollection.models);
    this.updateChildViews();
  }
});
